import React, { FunctionComponent } from 'react';
import {
  BrassTextField,
  BrassTextFieldProps,
  I18nService,
  II18n,
} from '../../../../';

const translations: II18n = {
  es: {
    tagLabel: 'Tag',
  },
  enUS: {
    tagLabel: 'Tag',
  },
  ptBR: {
    tagLabel: 'Tag',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

const TagField: FunctionComponent<BrassTextFieldProps> = (
  props: BrassTextFieldProps,
) => <BrassTextField {...props} name='tag' label={translate('tagLabel')} />;

export { TagField };
